import { defineComponent, PropType, toRef, Ref } from 'vue';
import { setupComponent } from '@studyportals/vue-platform';
import { ISectionContent } from './ISectionContent';
import { SectionContentCB } from './SectionContentCB';

export default defineComponent({
	props: {
		content: Object as PropType<ISectionContent>,
	},
	setup: (props) => {
		const codeBehind = new SectionContentCB(toRef(props, 'content') as Ref<ISectionContent>);

		return setupComponent(codeBehind);
	},
});
